import { useDeleteNode } from "./api/deleteNode";
import { Button } from "reactstrap";


const DeleteNode = ({handleCloseModal, nodeId}: DeleteNodeProps)  => {
  
  const deleteNodeMutation = useDeleteNode({ nodeId});
  const handleSubmit = async (): Promise<void> => {
    deleteNodeMutation.mutateAsync({ 
      nodeId: nodeId
    })

    handleCloseModal();
  }

  return (
    <>
        <label>Είστε σίγουροι οτι θέλετε να διαγράψετε τον Κόμβο;</label>
        <div>
          <Button style={{ margin: "10px" }} onClick={handleCloseModal}>Ακύρωση</Button>
          <Button style={{ margin: "10px" }} color='danger' onClick={handleSubmit}>Διαγραφή</Button>
        </div>
    </>
  )
}

interface DeleteNodeProps{
  nodeId: number;
  handleCloseModal: () => void;
}

export default DeleteNode;